import { ActionTypesScreenCommon } from "app/constants";
import LoggingAPI from "../api/loggingAPI";

export function changeScreenOrientation() {
  return (dispatch) => {
    dispatch({
      type: ActionTypesScreenCommon.CHANGE_ORIENTATION,
    });
  };
}

export function updateDataSources() {
  return (dispatch) => {
    dispatch({
      type: ActionTypesScreenCommon.DISPLAY_DATA_SOURCES,
    });
  };
}

export function logUserActivity(activity_data) {
  return async (dispatch) => {
      try {
          // Dispatch action to update Redux state
          dispatch({
              type: ActionTypesScreenCommon.LOG_USER_ACTIVITY,
              payload: activity_data
          });

          // Log the user activity via the API
          await LoggingAPI.logUserActivity(activity_data);
      } catch (error) {
          // Handle any errors that occur during the API request
          console.error("Error logging user activity:", error);
      }
  };
}
